import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from 'antd-mobile';
import BottomNav from 'src/components/BottomNav';
import Banner from 'src/views/components/Banner';
import CenterList from 'src/views/components/CenterList';
import FilterBar from 'src/components/FilterBar';
import './style/homeStyle.scss';
import Logo from 'src/assets/images/LOGO.png';
import shaixuan from 'src/assets/svgs/shaixuan.svg'
export default function Home() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('supply');
  const [showFilter, setShowFilter] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [filterParams, setFilterParams] = useState({
    plateTypes: [],
    provinces: [],
    organizations: []
  });

  const handleFilterChange = useCallback((params) => {
    setFilterParams(params);
  }, []);

  // 检查是否有筛选条件
  const hasActiveFilter = () => {
    return filterParams.plateTypes.length > 0 ||
      filterParams.provinces.length > 0 ||
      filterParams.organizations.length > 0;
  };



  const notices = [
    { text: '用户134****5678', action: '刚刚发布了求购100头仔猪的信息' },
    { text: '河南宏源猪场', action: '刚刚更新了租赁信息' },
    { text: '用户138****8888', action: '刚刚发布了供应500头肥猪的信息' }
  ];

  const handleSearch = (value) => {
    setSearchKey(value);
  };

  return (
    <div className='home-container'>
      {/* 搜索栏 */}
      <div className="search-bar">
        <img src={Logo} alt="Logo" className="logo-img" />
        <div className="search-wrapper">
          <SearchBar
            placeholder='搜索关键词（如二元母猪、定位栏）'
            onSearch={handleSearch}
          />
        </div>
      </div>

      {/* 轮播图 */}
      <Banner />

      {/* 发布按钮 */}
      <div className="match-section">
        <div className="match-row">
          <div className="match-btn match-btn-buyer" onClick={() => navigate('/publish?type=demand')}>
            <div className="match-btn-content">
              <div className="match-btn-text">我有需求</div>
              <div className="match-btn-desc">发需求，等卖家响应</div>
            </div>
          </div>
          <div className="match-btn match-btn-seller" onClick={() => navigate('/publish?type=supply')}>
            <div className="match-btn-content">
              <div className="match-btn-text">我要供应</div>
              <div className="match-btn-desc">挂货源，等买家咨询</div>
            </div>
          </div>
        </div>
      </div>

      {/* 金刚区 */}
      <div className="grid-menu">
        <div className="grid-card" onClick={() => navigate('/demand-supply?category=pig')}>
          <div className="grid-card-title">生猪交易</div>
        </div>
        <div className="grid-card" onClick={() => navigate('/demand-supply?category=equipment')}>
          <div className="grid-card-title">设备交易</div>
        </div>
        <div className="grid-card" onClick={() => navigate('/demand-supply?category=rental')}>
          <div className="grid-card-title">猪场租赁</div>
        </div>
        <div className="grid-card" onClick={() => navigate('/demand-supply?category=car')}>
          <div className="grid-card-title">运输车辆</div>
        </div>
      </div>

      {/* 标签栏 */}
      <div className="tabs-container">
        <div className="tabs">
          <div
            className={`tab ${activeTab === 'supply' ? 'active' : ''}`}
            onClick={() => setActiveTab('supply')}
          >
            看货源
          </div>
          <div
            className={`tab ${activeTab === 'demand' ? 'active' : ''}`}
            onClick={() => setActiveTab('demand')}
          >
            看需求
          </div>
        </div>
        <div
          className={`filter-toggle-btn ${showFilter ? 'active' : ''} ${hasActiveFilter() ? 'has-filter' : ''}`}
          onClick={() => setShowFilter(!showFilter)}
        >
          <img src={shaixuan} alt="筛选" style={{ width: 20, height: 20 }} />
        </div>
      </div>

      {/* 筛选面板 */}
      <FilterBar
        visible={showFilter}
        onFilterChange={handleFilterChange}
        showCategory={true}
        showArea={true}
        showOrganization={true}
      />

      {/* 列表内容 */}
      <CenterList
        activeTab={activeTab}
        searchKey={searchKey}
        plateTypes={filterParams.plateTypes}
        provinces={filterParams.provinces}
        organizations={filterParams.organizations}
        scrollMode="parent"
      />

      {/* 底部导航栏 */}
      <BottomNav />
    </div>
  );
}
